import PropTypes from 'prop-types';

import SubmitButtonBase from './SubmitButtonBase';

const typeStyles = {
  danger: 'button-danger',
  primary: 'button-primary',
  secondary: 'button-secondary',
};

const SubmitButton = ({ children, type, ...rest }) => (
  <SubmitButtonBase className={typeStyles[type] || ''} {...rest}>
    {children}
  </SubmitButtonBase>
);

SubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['danger', 'primary', 'secondary']).isRequired,
};

export default SubmitButton;
